import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/button/Button";
import useTranslation from "../hooks/i18n/useTranslation";
import "./NotFound.css";

const NotFound = ({ fallbackRoute }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(5);
  const [isTimerActive, setIsTimerActive] = useState(true);

  useEffect(() => {
    if (!isTimerActive) return;

    if (countdown <= 0) {
      navigate(fallbackRoute);
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown, isTimerActive, navigate, fallbackRoute]);

  const handleNavigation = path => {
    navigate(path);
  };

  const handleCancelRedirect = () => {
    setIsTimerActive(false);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">{t("92")}</h1>
        <p className="not-found-subtitle">{t("93")}</p>
        <p className="not-found-message">{t("94")}</p>
        {isTimerActive && countdown > 0 && (
          <p className="not-found-countdown">
            {countdown === 1
              ? t("294").replace("{count}", countdown)
              : t("293").replace("{count}", countdown)
            }
          </p>
        )}
        <div className="not-found-button-wrapper">
          <Button
            value={t("297")}
            onClick={() => handleNavigation(fallbackRoute)}
          />
          {isTimerActive && (
            <Button
              value={t("295")}
              onClick={handleCancelRedirect}
            />
          )}
          <Button
            value={t("298")}
            onClick={handleGoBack}
          />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
